import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import Notification from '@bluheadless/ui/src/molecules/notification/notification'

const useBHNotification = () => {
	const { closeSnackbar, enqueueSnackbar } = useSnackbar()

	const closeNotification = closeSnackbar

	const enqueueNotification = useCallback(
		({ enqueueProps = {}, uiProps = {} }) => {
			const { content: contentArg, key: keyArg, ...enqueuePropsArgs } = enqueueProps
			const { message, onClose, severity, ...uiPropsArgs } = uiProps
			const key = keyArg || Date.now()

			const content = contentArg || (
				<div>
					<Notification
						message={message}
						onClose={() => {
							closeSnackbar(key)
							if (onClose) onClose()
						}}
						severity={severity}
						{...uiPropsArgs}
					/>
				</div>
			)

			return enqueueSnackbar('', { content, key, ...enqueuePropsArgs })
		},
		[closeSnackbar, enqueueSnackbar]
	)

	return { closeNotification, enqueueNotification }
}

export { useBHNotification as useNotification }
